export const navigation = [
  {
    text: 'Comune',
    path: '/home',
    icon: 'home',
    requiredRoles: ['Proprietario', 'Collaboratore', 'Operatore']  
  },
  {
    text: 'Anagrafica personale',
    path: '/anagraficaPersonale', 
    icon: 'user',
    requiredRoles: ['Assistito']
  },
  {
    text: 'Assistiti',
    path: '/assistiti', 
    icon: 'group',
    requiredRoles: ['Collaboratore', 'Proprietario']
  },
  {
    text: 'Enti',
    path: '/enti', 
    icon: 'accountbox',
    requiredRoles: ['Collaboratore', 'Proprietario']
  },
  {
    text: 'Operatori',
    path: '/operatori', 
    icon: 'user',
    requiredRoles: ['Collaboratore', 'Proprietario']
  },
  {
    text: 'Punti di raccolta',
    path: '/puntiDiRaccolta', 
    icon: 'pinmap',
    requiredRoles: ['Collaboratore', 'Proprietario']
  },
  {
    text: 'Gestione Emergenze',
    path: '/emergenze', 
    icon: 'globe',
    requiredRoles: ['Collaboratore', 'Proprietario', 'Operatore']
  },
  // {
  //   text: 'Creazione Filtri',
  //   path: '/creazioneFiltri', 
  //   icon: 'filter',
  //   requiredRoles: ['Collaboratore','Proprietario']
  // }, 
    {
    text: 'Filtri',
    path: '/Filtri', 
    icon: 'filter',
    requiredRoles: ['Collaboratore','Proprietario']
  }, 
    {
    text: 'Impostazioni',
    path: '/impostazioni',
    icon: 'preferences',
    requiredRoles: ['Collaboratore','Proprietario']
  },
    {
    text: 'Emergenza (Operatori)',
    path: '/EmergenzaOperatore', 
    icon: 'globe',
    requiredRoles: ['Operatore']
  },
  ];
